// utils/generateCountingQuestions.js
export function generateCountingQuestions({
    numQuestions,
    maxPicturesPerCell,
    uploadedImages = [],
    selectedEmojis = []
  }) {
    if (!numQuestions || numQuestions < 1) return [];
  
    // pool of items to use
    const pool = [
      ...uploadedImages.map((f) => f.url || f.name), // prefer URL if uploaded
      ...selectedEmojis
    ];
  
    if (pool.length === 0) {
      throw new Error("No images or emojis provided");
    }
  
    const questions = [];
  
    for (let i = 0; i < numQuestions; i++) {
      // random choice from pool
      const item = pool[Math.floor(Math.random() * pool.length)];
  
      // random count between 1 and maxPicturesPerCell
      const count = Math.floor(Math.random() * maxPicturesPerCell) + 1;
  
      // fill an array with that many copies
      const images = Array(count).fill(item);
  
      questions.push({
        id: i + 1,
        question: "Count the pictures",
        images,
        answer: count.toString()
      });
    }
  
    return questions;
  }
  